export default __webpack_public_path__ + "static/media/home.e0cd0d18.svg";